module.exports = __webpack_public_path__ + "img/IMG-HANGYE2.8988592b.png";